import { useMutation } from "@tanstack/react-query";
import React from "react";
import { exportRmaDetailExcelApi } from "../../../../api/support/RMA";
import { downloadFile } from "../../../../util/FileDownload";
import moment from "moment";

const useExportExcelDetail = () => {
  const { mutate } = useMutation({
    mutationFn: (data: { rmaId: number }) => exportRmaDetailExcelApi(data),
    onSuccess: (res) => {
      if (res instanceof Blob) {
        downloadFile(
          res,
          `RMA_data_detail_${moment(new Date()).format("YYYY_MM_DD")}.xlsx`
        );
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });
  return { mutate };
};

export default useExportExcelDetail;
